export default "__VITE_ASSET__C0rSFzQ6__"